define('drops/circle/circle',[
    'jquery',
    'lq/drop',
    'lq/style',
    'underscore'
], function ($, Drop, Style, _) {
    'use strict';
    
    function Circle(options) {
        Drop.call(this, $('<div/>'), options);
        
        this.styleTheCircle();

        this.$element
            .addClass('boxToBorderSize');

        var $wrapper = $('<div />')
            .css({
                display: 'table-cell',
                width: this.data.size.x + 'px',
                height: this.data.size.y + 'px',
                textAlign: 'center',
                verticalAlign: 'middle'
            })
            .appendTo(this.$element);

        this.$text = $('<div/>')
            .text(this.data.value)
            .appendTo($wrapper);

        this.setColors(this.data.value);
    };

    Drop.extend(Circle);

    Circle.typeName = 'Circle';
    
    Circle.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        this.applyPosition();
    };

    Circle.prototype.styleTheCircle = function () {
        Style.renderStyles(this);

        // note: these css settings overwrite the styling, so the styling should be applied first!
        this.$element
            .css({
                borderRadius: '1000px'
            });
    };

    Circle.prototype.setColors = function (value) {
        var self = this;
        _.forEach(this.data.colorRanges, function (range) {
            var from = parseFloat(range.from);
            var to = parseFloat(range.to);
            if (from <= value && value <= to) {
                self.$element.css({ backgroundColor: range.color });
            }
        });
    };

    Circle.prototype.clearValue = function () {
        this.$text.text('0');
        this.setColors(0);
    };

    Circle.prototype.setValue = function (update) {
        this.$text.text(update.value);
        this.setColors(update.value);
    };

    return Circle;
});
